export const Currencies = {
  symbol: {
    bg: '€',
    en: '€'
  },
  suffix: {
    bg: ' €',
    en: ' €'
  }
} as const;
